/* @generated */

// ../src/popover/popover.tsx
import * as React2 from "react";

// ../src/popover/components/context.tsx
import * as React from "react";
var defaultPopoverProps = {
  open: false,
  triggerStrategy: "click",
  closeOnOutsideClick: true,
  hasScrollLock: false,
  isPortaled: true,
  offsetDistance: 4,
  placement: "bottom",
  spacing: "small",
  trapFocus: true,
  shouldFocusContentOnOpen: true,
  hoverBufferTime: 200,
  anchorEl: null,
  boundaryEl: null,
  shouldHideOnAnchorHidden: true
};
var defaultPopoverContext = {
  open: defaultPopoverProps.open,
  spacing: defaultPopoverProps.spacing,
  placement: defaultPopoverProps.placement,
  anchorEl: null,
  bodyEl: null,
  setBodyEl: () => {
  },
  boundaryEl: null,
  triggerEl: null,
  setTriggerEl: () => {
  },
  containerEl: null,
  setContainerEl: () => {
  },
  openPopover: () => {
  },
  closePopover: () => {
  },
  triggerStrategy: defaultPopoverProps.triggerStrategy,
  closeOnOutsideClick: defaultPopoverProps.closeOnOutsideClick,
  shouldFocusContentOnOpen: defaultPopoverProps.shouldFocusContentOnOpen,
  isHoveringTrigger: React.createRef(),
  setIsHoveringTrigger: () => {
  },
  isHoveringContent: React.createRef(),
  setIsHoveringContent: () => {
  },
  isReturningFocus: React.createRef(),
  setIsReturningFocus: () => {
  },
  queueClose: () => {
  },
  hasScrollLock: defaultPopoverProps.hasScrollLock,
  isPortaled: defaultPopoverProps.isPortaled,
  offsetDistance: defaultPopoverProps.offsetDistance,
  trapFocus: defaultPopoverProps.trapFocus,
  shouldHideOnAnchorHidden: defaultPopoverProps.shouldHideOnAnchorHidden,
  availableHeight: void 0,
  setAvailableHeight: () => {
  }
};
var PopoverContext = React.createContext(defaultPopoverContext);

// ../src/popover/popover.tsx
var PopoverRoot = ({ children, ...props }) => {
  const {
    open = defaultPopoverProps.open,
    onToggle,
    triggerStrategy = defaultPopoverProps.triggerStrategy,
    closeOnOutsideClick = defaultPopoverProps.closeOnOutsideClick,
    hasScrollLock = defaultPopoverProps.hasScrollLock,
    isPortaled = defaultPopoverProps.isPortaled,
    offsetDistance = defaultPopoverProps.offsetDistance,
    placement = defaultPopoverProps.placement,
    spacing = defaultPopoverProps.spacing,
    trapFocus = defaultPopoverProps.trapFocus,
    shouldFocusContentOnOpen = defaultPopoverProps.shouldFocusContentOnOpen,
    anchorEl = defaultPopoverProps.anchorEl,
    boundaryEl = defaultPopoverProps.boundaryEl,
    shouldHideOnAnchorHidden = defaultPopoverProps.shouldHideOnAnchorHidden,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    hoverBufferTime = defaultPopoverProps.hoverBufferTime,
    withCloseButton
  } = props;
  const [availableHeight, setAvailableHeight] = React2.useState(void 0);
  const [triggerEl, _setTriggerEl] = React2.useState(null);
  const [bodyEl, setBodyEl] = React2.useState(null);
  const setTriggerEl = (el) => {
    _setTriggerEl(el);
  };
  const [containerEl, setContainerEl] = React2.useState(null);
  const isReturningFocus = React2.useRef(false);
  const setIsReturningFocus = React2.useCallback((returning) => {
    isReturningFocus.current = returning;
  }, []);
  const isHoveringTrigger = React2.useRef(false);
  const setIsHoveringTrigger = React2.useCallback((hovering) => {
    isHoveringTrigger.current = hovering;
  }, []);
  const isHoveringContent = React2.useRef(false);
  const setIsHoveringContent = React2.useCallback((hovering) => {
    isHoveringContent.current = hovering;
  }, []);
  const hoverTimeout = React2.useRef(null);
  const setOpen = React2.useCallback(
    (nextOpen) => {
      onToggle == null ? void 0 : onToggle(nextOpen, triggerEl);
    },
    [onToggle, triggerEl]
  );
  const openPopover = React2.useCallback(() => {
    setOpen(true);
  }, [setOpen]);
  const closePopover = React2.useCallback(
    (returnFocus = true) => {
      if (!open) return;
      setOpen(false);
      if (triggerEl && returnFocus) {
        setIsReturningFocus(true);
        triggerEl.focus();
        setTimeout(() => {
          setIsReturningFocus(false);
        }, 0);
      }
    },
    [setOpen, triggerEl, setIsReturningFocus, open]
  );
  const queueClose = React2.useCallback(() => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
      hoverTimeout.current = null;
    }
    hoverTimeout.current = setTimeout(() => {
      if (!isHoveringTrigger.current && !isHoveringContent.current) {
        closePopover(false);
      }
    }, hoverBufferTime);
  }, [closePopover, hoverBufferTime]);
  React2.useEffect(() => {
    return () => {
      if (hoverTimeout.current) {
        clearTimeout(hoverTimeout.current);
        hoverTimeout.current = null;
      }
    };
  }, []);
  const contextValue = {
    open,
    triggerStrategy,
    closeOnOutsideClick,
    hasScrollLock,
    isPortaled,
    offsetDistance,
    placement,
    spacing,
    trapFocus,
    triggerEl,
    setTriggerEl,
    containerEl,
    setContainerEl,
    openPopover,
    closePopover,
    isHoveringTrigger,
    setIsHoveringTrigger,
    isHoveringContent,
    setIsHoveringContent,
    isReturningFocus,
    setIsReturningFocus,
    queueClose,
    shouldFocusContentOnOpen,
    anchorEl,
    boundaryEl,
    shouldHideOnAnchorHidden,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    withCloseButton,
    availableHeight,
    setAvailableHeight,
    bodyEl,
    setBodyEl
  };
  return /* @__PURE__ */ React2.createElement(PopoverContext.Provider, { value: contextValue }, children);
};
PopoverRoot.displayName = "Popover";

// ../src/popover/components/trigger.tsx
import * as React3 from "react";
import { Button } from "@dropbox/dig-components/buttons";

// ../src/_global/components/slot.tsx
import { createSlot, createSlottable } from "@radix-ui/react-slot";
var Slot = createSlot("DIG_Slot");
var Slottable = createSlottable("DIG_Slottable");

// ../src/popover/components/trigger.tsx
import { useMediaQuery } from "@react-hookz/web";
var PopoverTrigger = ({
  children,
  asChild,
  variant = "primary",
  ...buttonProps
}) => {
  const triggerProps = useTriggerProps();
  if (asChild && React3.isValidElement(children)) {
    return /* @__PURE__ */ React3.createElement(Slot, { ...triggerProps }, children);
  }
  return /* @__PURE__ */ React3.createElement(Button, { variant, ...buttonProps, ...triggerProps }, children);
};
PopoverTrigger.displayName = "Popover.Trigger";
var useTriggerProps = () => {
  const context = React3.useContext(PopoverContext);
  const {
    setTriggerEl,
    openPopover,
    closePopover,
    triggerStrategy,
    open,
    containerEl,
    setIsHoveringTrigger,
    isReturningFocus,
    queueClose
  } = context;
  const tabbingToContent = React3.useRef(false);
  const isHoverSupported = useMediaQuery("(hover: hover)");
  const handleClick = React3.useCallback(() => {
    open ? closePopover() : openPopover();
  }, [open, closePopover, openPopover]);
  const handleMouseEnter = React3.useCallback(() => {
    setIsHoveringTrigger(true);
    openPopover();
  }, [setIsHoveringTrigger, openPopover]);
  const handleMouseLeave = React3.useCallback(() => {
    setIsHoveringTrigger(false);
    queueClose();
  }, [setIsHoveringTrigger, queueClose]);
  const handlePointerDown = React3.useCallback(() => {
    if (open) {
      closePopover(false);
      return;
    }
    openPopover();
  }, [open, closePopover, openPopover]);
  const handleFocus = React3.useCallback(() => {
    if (!isReturningFocus.current) {
      openPopover();
    }
  }, [isReturningFocus, openPopover]);
  const handleKeyDown = React3.useCallback(
    (event) => {
      if (open) {
        if (event.key === "Tab" && !event.shiftKey) {
          if (containerEl) {
            tabbingToContent.current = true;
            event.preventDefault();
            containerEl.focus();
          }
        } else if (event.key === "Escape") {
          closePopover(false);
        }
      }
    },
    [open, containerEl, closePopover]
  );
  const handleBlur = React3.useCallback(() => {
    if (open && !tabbingToContent.current) {
      closePopover(false);
    }
    tabbingToContent.current = false;
  }, [open, closePopover]);
  const triggerProps = React3.useMemo(
    () => ({
      ref: setTriggerEl,
      "aria-haspopup": "dialog",
      "aria-expanded": open ? "true" : "false",
      ...triggerStrategy === "click" ? { onClick: handleClick } : {},
      ...triggerStrategy === "hover" && isHoverSupported ? {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur
      } : {},
      ...triggerStrategy === "hover" && !isHoverSupported ? {
        onPointerDown: handlePointerDown
      } : {}
    }),
    [
      setTriggerEl,
      open,
      triggerStrategy,
      isHoverSupported,
      handleClick,
      handleMouseEnter,
      handleMouseLeave,
      handleFocus,
      handleKeyDown,
      handleBlur,
      handlePointerDown
    ]
  );
  return triggerProps;
};

// ../src/popover/components/overlay.tsx
import * as React5 from "react";
import { useIsomorphicLayoutEffect } from "@react-hookz/web";
import {
  useFloating,
  autoUpdate,
  flip,
  shift,
  limitShift,
  offset,
  hide,
  size
} from "@floating-ui/react";
import { ELEVATED_BASE_INDEX, Layer } from "@dropbox/dig-components/layer";

// ../src/_global/roundByDPR.ts
function roundByDPR(value) {
  const dpr = typeof window !== "undefined" && typeof (window == null ? void 0 : window.devicePixelRatio) === "number" ? window.devicePixelRatio : 1;
  return Math.round(value * dpr) / dpr;
}

// ../src/popover/components/overlay.tsx
import { ClickOutside } from "@dropbox/dig-components/click_outside";

// ../src/popover/hooks/use-focus-trap.ts
import React4 from "react";
function useFocusTrap(containerEl, active) {
  const handleKeyDown = React4.useCallback(
    (evt) => {
      if (!containerEl || evt.key !== "Tab") return;
      const focusableEls = getFocusableElements(containerEl);
      if (focusableEls.length === 0) {
        evt.preventDefault();
        return;
      }
      const firstEl = focusableEls[0];
      const lastEl = focusableEls[focusableEls.length - 1];
      const activeEl = typeof document !== "undefined" ? document.activeElement : null;
      if (evt.shiftKey) {
        if (activeEl === firstEl) {
          evt.preventDefault();
          lastEl.focus();
        }
      } else {
        if (activeEl === lastEl) {
          evt.preventDefault();
          firstEl.focus();
        }
      }
    },
    [containerEl]
  );
  React4.useEffect(() => {
    if (!containerEl) return;
    if (!active) return;
    containerEl.addEventListener("keydown", handleKeyDown);
    return () => {
      containerEl.removeEventListener("keydown", handleKeyDown);
    };
  }, [containerEl, handleKeyDown, active]);
}
var getFocusableElements = (node) => {
  if (!node) return [];
  const selectors = [
    "a[href]",
    "button:not([disabled])",
    "textarea:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
  ];
  return Array.from(node.querySelectorAll(selectors.join(","))).filter(
    (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden")
  );
};

// ../src/popover/components/overlay.tsx
import { usePreviousDistinct } from "@react-hookz/web";
import { RemoveScroll } from "react-remove-scroll";
var PopoverOverlay = ({ children }) => {
  const context = React5.useContext(PopoverContext);
  const {
    open,
    anchorEl,
    boundaryEl,
    placement: _initialPlacement,
    offsetDistance = 4,
    hasScrollLock,
    trapFocus,
    shouldFocusContentOnOpen,
    isPortaled = true,
    triggerEl,
    containerEl,
    closePopover,
    closeOnOutsideClick,
    triggerStrategy,
    shouldHideOnAnchorHidden = true,
    setAvailableHeight
  } = context;
  useFocusTrap(containerEl, open && trapFocus);
  const prevOpen = usePreviousDistinct(open);
  const [currentBoundary, setCurrentBoundary] = React5.useState(void 0);
  React5.useLayoutEffect(() => {
    setCurrentBoundary(boundaryEl || void 0);
  }, [boundaryEl]);
  React5.useEffect(() => {
    if (prevOpen === false && open && containerEl && triggerStrategy !== "hover" && shouldFocusContentOnOpen) {
      containerEl.focus();
    }
  }, [open, prevOpen, triggerStrategy, containerEl, shouldFocusContentOnOpen]);
  const handleClickOutside = React5.useCallback(() => {
    if (closeOnOutsideClick) {
      closePopover(false);
    }
  }, [closeOnOutsideClick, closePopover]);
  const applyFn = React5.useCallback(
    ({ availableHeight }) => {
      setAvailableHeight(availableHeight);
    },
    [setAvailableHeight]
  );
  const {
    x,
    y,
    refs,
    strategy,
    middlewareData,
    placement: _floatingPlacement
  } = useFloating({
    placement: _initialPlacement,
    strategy: "absolute",
    whileElementsMounted: (reference, floating, update) => autoUpdate(reference, floating, update, {
      elementResize: true
    }),
    middleware: [
      offset(offsetDistance),
      flip({
        boundary: currentBoundary,
        fallbackStrategy: "initialPlacement"
      }),
      currentBoundary ? shift({
        crossAxis: true,
        mainAxis: true,
        boundary: currentBoundary
      }) : shift({ limiter: limitShift() }),
      // Always apply size middleware to set available height
      size({ apply: applyFn }),
      // @see https://floating-ui.com/docs/hide#strategy
      ...shouldHideOnAnchorHidden ? [
        hide({
          strategy: "referenceHidden",
          boundary: currentBoundary
        })
      ] : [],
      // @see https://floating-ui.com/docs/hide#strategy
      hide({
        strategy: "escaped",
        boundary: currentBoundary
      })
    ]
  });
  useIsomorphicLayoutEffect(() => {
    const referenceElement = anchorEl ? anchorEl : triggerEl;
    if (referenceElement) {
      refs.setReference(referenceElement);
    }
  }, [refs, anchorEl, triggerEl]);
  const isAnchorHidden = middlewareData.hide && middlewareData.hide.referenceHidden ? middlewareData.hide.referenceHidden : false;
  const isFloatingEscaped = middlewareData.hide && middlewareData.hide.escaped ? middlewareData.hide.escaped : false;
  if (!open) return null;
  return /* @__PURE__ */ React5.createElement(Layer, { _elevateByZ: ELEVATED_BASE_INDEX, _preferAbsolute: true, isPortaled }, /* @__PURE__ */ React5.createElement(
    "div",
    {
      ref: refs.setFloating,
      style: {
        position: strategy,
        top: "0",
        left: "0",
        visibility: isFloatingEscaped || isAnchorHidden ? "hidden" : void 0,
        transform: `translate3d(${roundByDPR(Number(x))}px,${roundByDPR(Number(y))}px,0)`
      }
    },
    /* @__PURE__ */ React5.createElement(RemoveScroll, { enabled: open && hasScrollLock }, /* @__PURE__ */ React5.createElement(
      ClickOutside,
      {
        isActive: open,
        onClickOutside: handleClickOutside,
        shouldPropagateMouseEvents: true,
        isClickThroughPortaled: isPortaled,
        isBlock: true
      },
      children
    ))
  ));
};
PopoverOverlay.displayName = "Popover.Overlay";

// ../src/popover/components/header.tsx
import * as React6 from "react";

// ../src/popover/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var closeButton = "dig-x7xems9_22-5-0";
var gridSpacingBottom = "var(--dig-x7xems1_22-5-0)";
var gridSpacingLeft = "var(--dig-x7xems2_22-5-0)";
var gridSpacingRight = "var(--dig-x7xems3_22-5-0)";
var gridSpacingTop = "var(--dig-x7xems0_22-5-0)";
var popoverBody = "dig-x7xemsc_22-5-0";
var popoverContentInnerWrapper = "dig-x7xems8_22-5-0";
var popoverContentOuterWrapper = "dig-x7xems7_22-5-0";
var popoverGridDivider = _7a468({ defaultClassName: "dig-x7xemsd_22-5-0", variantClassNames: { isFullWidth: { true: "dig-x7xemse_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var popoverHeaderRecipe = _7a468({ defaultClassName: "dig-x7xemsa_22-5-0", variantClassNames: { withCloseButton: { true: "dig-x7xemsb_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });

// ../src/popover/components/header.tsx
var PopoverHeader = ({ children }) => {
  const context = React6.useContext(PopoverContext);
  const { withCloseButton } = context;
  return /* @__PURE__ */ React6.createElement("div", { className: popoverHeaderRecipe({ withCloseButton: !!withCloseButton }) }, children);
};
PopoverHeader.displayName = "Popover.Header";

// ../src/popover/components/body.tsx
import * as React7 from "react";
import { makeScrollbarClassName } from "@dropbox/dig-foundations";
import classNames from "classnames";
var PopoverBody = ({ children, className, ...rest }) => {
  const { setBodyEl } = React7.useContext(PopoverContext);
  return /* @__PURE__ */ React7.createElement(
    "div",
    {
      ref: setBodyEl,
      className: classNames(
        popoverBody,
        makeScrollbarClassName({
          borderRadius: "Large"
        }),
        className
      ),
      ...rest
    },
    children
  );
};
PopoverBody.displayName = "Popover.Body";

// ../src/popover/components/divider.tsx
import * as React9 from "react";

// ../src/_global/components/internal_box.tsx
import * as React8 from "react";
import { Box } from "@dropbox/dig-foundations";
var InternalBox = React8.forwardRef(
  ({ children, className: _cls, _dangerouslySetClassName, sx, ...rest }, ref) => {
    return /* @__PURE__ */ React8.createElement(Box, { ...sx, ...rest, className: _dangerouslySetClassName, ref }, children);
  }
);

// ../src/popover/components/divider.tsx
var PopoverDivider = ({
  isFullWidth = false,
  marginTop = "Micro Small",
  marginBottom = "Micro Small"
}) => {
  return /* @__PURE__ */ React9.createElement(
    InternalBox,
    {
      sx: {
        borderTop: "Solid",
        borderColor: "Border Subtle",
        marginTop,
        marginBottom
      },
      _dangerouslySetClassName: popoverGridDivider({ isFullWidth }),
      role: "separator"
    }
  );
};
PopoverDivider.displayName = "Popover.Divider";

// ../src/popover/components/content.tsx
import * as React10 from "react";

// ../src/popover/utilities.ts
function toPxString(value) {
  if (typeof value === "number") {
    return `${value}px`;
  }
  return value != null ? value : "";
}
var SPACING_MAP = {
  small: ["var(--dig-spacing__dimension__12)", "var(--dig-spacing__dimension__12)"],
  medium: ["var(--dig-spacing__dimension__12)", "var(--dig-spacing__dimension__16)"],
  large: ["var(--dig-spacing__dimension__20)", "var(--dig-spacing__dimension__16)"],
  xlarge: ["var(--dig-spacing__dimension__16)", "var(--dig-spacing__dimension__20)"]
};
function getPopoverSpacing(spacing, paddingX, paddingY, paddingTop, paddingBottom, paddingLeft, paddingRight) {
  var _a, _b, _c, _d;
  const [defaultX, defaultY] = SPACING_MAP[spacing];
  return {
    top: toPxString((_a = paddingTop != null ? paddingTop : paddingY) != null ? _a : defaultY),
    left: toPxString((_b = paddingLeft != null ? paddingLeft : paddingX) != null ? _b : defaultX),
    right: toPxString((_c = paddingRight != null ? paddingRight : paddingX) != null ? _c : defaultX),
    bottom: toPxString((_d = paddingBottom != null ? paddingBottom : paddingY) != null ? _d : defaultY)
  };
}

// ../src/popover/components/content.tsx
import { IconButton } from "@dropbox/dig-components/buttons";
import { CloseLine } from "@dropbox/dig-icons/assets";
import { UIIcon } from "@dropbox/dig-icons";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames2 from "classnames";
import { makeScrollbarClassName as makeScrollbarClassName2 } from "@dropbox/dig-foundations";
var PopoverContent = React10.forwardRef(({ children, asChild = false, maxHeight, maxWidth }, _ref) => {
  const context = React10.useContext(PopoverContext);
  const {
    spacing,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    withCloseButton,
    closePopover,
    triggerStrategy,
    setContainerEl,
    bodyEl,
    availableHeight
  } = context;
  const { top, left, right, bottom } = getPopoverSpacing(
    spacing,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight
  );
  const maxDimensions = useMaxDimensions(maxHeight, maxWidth, availableHeight);
  const handleBoxKeyDown = (event) => {
    if (event.key === "Escape") {
      closePopover();
    }
  };
  const handleMouseEnter = () => {
    if (triggerStrategy === "hover") {
      context.setIsHoveringContent(true);
    }
  };
  const handleMouseLeave = () => {
    if (triggerStrategy === "hover") {
      context.setIsHoveringContent(false);
      context.queueClose();
    }
  };
  const nonVisualProps = {
    ref: setContainerEl,
    tabIndex: -1,
    role: "dialog",
    "aria-modal": true,
    onKeyDown: handleBoxKeyDown,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  };
  return asChild ? /* @__PURE__ */ React10.createElement(Slot, { ...nonVisualProps }, children) : /* @__PURE__ */ React10.createElement(
    InternalBox,
    {
      sx: {
        outline: { focusVisible: "Focus Outline" },
        borderRadius: "Large",
        backgroundColor: "Background Raised",
        boxShadow: "Raised",
        borderColor: "Border Subtle",
        borderStyle: "Solid",
        position: "relative"
      },
      _dangerouslySetClassName: classNames2(popoverContentOuterWrapper),
      style: {
        ...assignInlineVars({
          [gridSpacingTop]: top,
          [gridSpacingBottom]: bottom,
          [gridSpacingLeft]: left,
          [gridSpacingRight]: right
        })
      },
      ...nonVisualProps
    },
    /* @__PURE__ */ React10.createElement(
      InternalBox,
      {
        sx: {
          borderRadius: "Large"
        },
        _dangerouslySetClassName: classNames2(
          popoverContentInnerWrapper,
          makeScrollbarClassName2({
            borderRadius: "Large"
          })
        ),
        style: {
          ...maxDimensions,
          ...!bodyEl ? { overflowY: "auto" } : {}
        }
      },
      children
    ),
    !!withCloseButton && /* @__PURE__ */ React10.createElement(
      IconButton,
      {
        className: closeButton,
        variant: "borderless",
        shape: "standard",
        size: "medium",
        "aria-label": withCloseButton,
        onClick: () => closePopover()
      },
      /* @__PURE__ */ React10.createElement(UIIcon, { src: CloseLine })
    )
  );
});
PopoverContent.displayName = "Popover.Content";
var SCREEN_EDGE_OFFSET = 8;
var useMaxDimensions = (maxHeight, maxWidth, availableHeight) => {
  return React10.useMemo(() => {
    const result = {};
    const heightValues = [];
    if (maxHeight) {
      if (typeof maxHeight === "number") {
        heightValues.push(`${maxHeight}px`);
      } else {
        heightValues.push(maxHeight);
      }
    }
    if (availableHeight) {
      heightValues.push(`${availableHeight - SCREEN_EDGE_OFFSET}px`);
    }
    if (heightValues.length > 0) {
      result.maxHeight = `min(${heightValues.join(", ")})`;
    }
    if (maxWidth) {
      if (typeof maxWidth === "number") {
        result.maxWidth = `${maxWidth}px`;
      } else {
        result.maxWidth = maxWidth;
      }
    }
    return {
      maxHeight: result.maxHeight ? wrapDimensionValue(result.maxHeight) : void 0,
      maxWidth: result.maxWidth ? wrapDimensionValue(result.maxWidth) : void 0
    };
    return result;
  }, [maxHeight, maxWidth, availableHeight]);
};
var wrapDimensionValue = (value) => `calc(${value} - 2px)`;

// ../src/popover/index.ts
var Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Overlay: PopoverOverlay,
  Header: PopoverHeader,
  Body: PopoverBody,
  Divider: PopoverDivider,
  Content: PopoverContent
});
export {
  Popover
};
